import { DoctorsDashboardPatientInsightsHttpClient, InsightImage, PatientInsightsResponseModel } from "doctors-dashboard";
import { IPatientInsightsApiService} from "./patient-insights-api.interface";
import { ORPYXSI_API_URL, PATIENT_INSIGHTS_API_VERSION_STRING } from "appConstants";
import { CachedInsightImage, InsightImageStatus } from "../patient-information-page/components/patient-information-daily-insights/patient-information-daily-insights.interface";

export class DailyInsightsApiService implements IPatientInsightsApiService {
  private static instance: DailyInsightsApiService;
  private readonly client: DoctorsDashboardPatientInsightsHttpClient;

  private constructor() {
    let url = ORPYXSI_API_URL;
    this.client = new DoctorsDashboardPatientInsightsHttpClient(url);
  }

  public static getInstance(): DailyInsightsApiService {
    if (!DailyInsightsApiService.instance) {
      DailyInsightsApiService.instance = new DailyInsightsApiService();
    }
    return DailyInsightsApiService.instance;
  }

  async getPatientInsights(
    patientId: number,
    date?: string,
    numberOfImages?: number,
    descending?: boolean,
    generatedBefore?: number
  ): Promise<CachedInsightImage[]> {
    const response: PatientInsightsResponseModel = await this.client.getPatientInsights(
      patientId,
      date,
      numberOfImages,
      descending,
      generatedBefore,
      PATIENT_INSIGHTS_API_VERSION_STRING
    );
    
    // For some reason, the InsightImage type from NSwag has date and url as optional. Safely coerce that into our own type with those fields guaranteed.
    const filteredResponse = (response.images || []).filter(image => image.url && image.date)

    const finalResponse: CachedInsightImage[] = (filteredResponse || []).map(image => ({
      status: InsightImageStatus.LOADING,
      blobUrl: undefined,
      date: image.date!,
      url: image.url!,
    }))
    
    return finalResponse;
  }
}
